/*
 * CHI-20: wires the REAL tRPC ticketing procedures (contract v4) into getTicketingApi().
 * Every ticket hook/component calls useTicketingApiWiring() first; the app's existing
 * trpc provider supplies utils.client. No App.tsx/main.tsx edit. Tests inject mocks
 * with setTicketingApi(), which takes precedence.
 */
import { trpc } from "@/lib/trpc";
import { createTrpcTicketingApi, registerRealTicketingApi } from "@/lib/ticketingApi";

export function useTicketingApiWiring() {
  let utils: ReturnType<typeof trpc.useUtils> | null = null;
  try {
    utils = trpc.useUtils();
  } catch {
    utils = null; // no provider (isolated tests): injected API is used
  }
  if (utils?.client) registerRealTicketingApi(() => createTrpcTicketingApi(utils!.client));
  return utils;
}
